import axios from "axios";
import { baseUrlAPI } from "@/config/api";

const HOST = baseUrlAPI;

export default {
  get(payload = {}) {
    const params = payload.params || {};
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/categorias`,
        method: "get",
        params
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  getById(payload = {}) {
    const categoriaId = payload.categoriaId || "";

    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/categorias/${categoriaId}`,
        method: "get"
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  put(payload = {}) {
    const categoriaId = payload.categoriaId;

    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/categorias/${categoriaId}`,
        method: "patch",
        data: payload.data
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  post(payload = {}) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/categorias`,
        method: "post",
        data: payload.data
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  delete(payload = {}) {
    const categoriaId = payload.categoriaId;
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/categorias/${categoriaId}`,
        method: "delete"
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
};
